import React from "react";
import header_img1 from "styles/common/img/lounge/q_close.png";
import { useHistory } from "react-router-dom";
import queryStirng from "query-string";

const ExchangeHeader = () => {
    const history = useHistory();

    const search = history.location.search;
    const { tabState } = queryStirng.parse(search);

    //뒤로가기 버튼
    const handlePage = () => {
        if (tabState !== "undefined") {
            history.replace("/starshop?tab=3");
        } else {
            history.replace("/starshop?tab=2");
        }
    };

    return (
        <div className="head">
            <div className="head_qa2 clear">
                <button className="fl baekbt">
                    <img src={header_img1} alt="뒤로가기" onClick={handlePage} />
                </button>
                <div className="fl setTitle">목표 달성 교환하기</div>
            </div>
        </div>
    );
};

export default ExchangeHeader;
